import Navbar from "./Navbar";
import FinalCTA from "./FinalCTA";
import Footer from "./Footer";
import { Mail, ShieldCheck } from "lucide-react";

export default function LegalPageLayout({
    title,
    subtitle,
    summaryTitle,
    summaryItems,
    sections,
    note,
    contactTitle = "Questions about this page?",
    contactBody = "If you have any questions about this policy, need support, or want to request more information, contact our team.",
}) {
    return (
        <div className="bg-[#f8f5ef] text-slate-900 min-h-screen">
            <Navbar />

            <main className="pt-[7rem]">
                <section className="relative overflow-hidden bg-gradient-to-r from-emerald-900 via-teal-800 to-emerald-700 text-white border-b border-emerald-900/30">
                    <div className="absolute inset-0 opacity-20 bg-[radial-gradient(circle_at_top_left,_white_0%,_transparent_40%),radial-gradient(circle_at_bottom_right,_white_0%,_transparent_35%)]" />
                    <div className="relative max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-14 md:py-16 text-center">
                        <h1 className="font-serif text-4xl md:text-5xl tracking-tight">{title}</h1>
                        <p className="mt-4 text-white/80 max-w-2xl mx-auto leading-relaxed">
                            {subtitle}
                        </p>
                    </div>
                </section>

                <section className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-14">
                    <div className="rounded-3xl border border-emerald-100 bg-white shadow-sm p-6 md:p-7">
                        <div className="flex items-start gap-3">
                            <div className="w-10 h-10 rounded-2xl bg-emerald-50 text-emerald-700 flex items-center justify-center shrink-0">
                                <ShieldCheck className="w-5 h-5" />
                            </div>
                            <div className="flex-1">
                                <h2 className="text-lg md:text-xl font-semibold text-slate-900">
                                    {summaryTitle}
                                </h2>
                                <div className="mt-4 grid sm:grid-cols-2 gap-3">
                                    {summaryItems.map((item) => (
                                        <div
                                            key={item}
                                            className="rounded-2xl bg-slate-50 border border-slate-100 px-4 py-3 text-sm text-slate-700"
                                        >
                                            {item}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>

                    {note ? (
                        <div className="mt-6 rounded-2xl border border-emerald-200 bg-emerald-50/70 px-5 py-4 text-sm text-emerald-900 leading-relaxed">
                            {note}
                        </div>
                    ) : null}

                    <div className="mt-10 space-y-10">
                        {sections.map((section) => (
                            <section key={section.heading}>
                                <h2 className="font-serif text-2xl md:text-[1.9rem] text-slate-900 tracking-tight">
                                    {section.heading}
                                </h2>
                                <div className="mt-4 space-y-4 text-[15px] leading-7 text-slate-700">
                                    {section.paragraphs?.map((paragraph) => (
                                        <p key={paragraph}>{paragraph}</p>
                                    ))}
                                    {section.bullets ? (
                                        <ul className="space-y-2 pl-5 list-disc marker:text-emerald-700">
                                            {section.bullets.map((bullet) => (
                                                <li key={bullet}>{bullet}</li>
                                            ))}
                                        </ul>
                                    ) : null}
                                </div>
                            </section>
                        ))}
                    </div>

                    <div className="mt-10 rounded-2xl bg-emerald-800 text-white p-5 md:p-6">
                        <div className="flex items-start gap-3">
                            <div className="w-10 h-10 rounded-xl bg-white/10 flex items-center justify-center shrink-0">
                                <Mail className="w-5 h-5" />
                            </div>
                            <div>
                                <h3 className="font-semibold text-lg">{contactTitle}</h3>
                                <p className="mt-2 text-white/80 leading-relaxed">{contactBody}</p>
                                <div className="mt-3 text-sm text-white/90">
                                    Email:{" "}
                                    <a
                                        href="mailto:hello@genesisrecovery.ai"
                                        className="underline underline-offset-4 hover:text-white"
                                    >
                                        hello@genesisrecovery.ai
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <FinalCTA />
            </main>

            <Footer />
        </div>
    );
}
